import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

import { PurchaseProps } from './types';

const Purchase = ({
  className,
  color = WHITE,
  onClick,
}: PurchaseProps): JSX.Element => (
  <svg
    className={className}
    onClick={onClick}
    viewBox="0 0 24 24"
    fill="none"
    width="24"
    height="24"
  >
    <g id="wt.purchase">
      <path
        d="M4.71023 9.0107C4.77303 7.95096 4.80443 7.42108 5.03076 7.01899C5.23 6.66501 5.5323 6.3801 5.89744 6.20215C6.31222 6 6.84302 6 7.90463 6H16.0949C17.1565 6 17.6873 6 18.1021 6.20215C18.4672 6.3801 18.7695 6.66501 18.9688 7.01899C19.1951 7.42108 19.2265 7.95095 19.2893 9.0107L19.5981 14.2214C19.7378 16.5802 19.8077 17.7596 19.3919 18.6668C19.0264 19.4641 18.409 20.1192 17.6347 20.5312C16.7537 21 15.5722 21 13.2093 21H10.7902C8.42732 21 7.24585 21 6.36485 20.5312C5.59054 20.1192 4.97311 19.4641 4.60762 18.6668C4.19178 17.7596 4.26167 16.5802 4.40145 14.2214L4.71023 9.0107Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 5.5V5C15 3.34315 13.6569 2 12 2V2C10.3431 2 9 3.34315 9 5V5.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 9V9.5C15 11.1569 13.6569 12.5 12 12.5V12.5C10.3431 12.5 9 11.1569 9 9.5V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default Purchase;
